import React, { useState, useEffect } from 'react';
import { Globe, Mail, MapPin, ArrowRight } from 'lucide-react';

const ComingSoon = () => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    document.title = 'Sikka IT Solutions | AI-Powered Custom Software Development - Coming Soon';
    const interval = setInterval(() => {
      setDots(prev => prev.length >= 3 ? '' : prev + '.');
    }, 600);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-slate-950 text-white flex flex-col" data-testid="coming-soon-page">
      {/* Subtle grid background */}
      <div className="fixed inset-0 opacity-[0.03]" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)',
        backgroundSize: '60px 60px'
      }} />

      {/* Header */}
      <header className="relative z-10 py-6 px-6 md:px-12">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <img
            src={require('../assets/sikka-logo.jpg')}
            alt="Sikka IT Solutions"
            className="h-10 md:h-12 w-auto object-contain rounded"
          />
          <a
            href="mailto:raunak@sikkanet.com"
            className="text-sm text-slate-400 hover:text-white transition-colors flex items-center gap-2"
            data-testid="header-email-link"
          >
            <Mail className="h-4 w-4" />
            <span className="hidden sm:inline">raunak@sikkanet.com</span>
          </a>
        </div>
      </header>

      {/* Main Content */}
      <main className="relative z-10 flex-1 flex items-center justify-center px-6">
        <div className="max-w-3xl w-full text-center">
          {/* Accent line */}
          <div className="flex items-center justify-center gap-3 mb-8">
            <div className="h-px w-12 bg-blue-500" />
            <span className="text-xs tracking-[0.3em] uppercase text-blue-400 font-medium">Launching Soon</span>
            <div className="h-px w-12 bg-blue-500" />
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight mb-6">
            Our Website Will Be
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400 mt-2">
              Live Soon
            </span>
          </h1>

          <p className="text-base md:text-lg text-slate-400 max-w-xl mx-auto mb-4 leading-relaxed">
            We're setting up <strong className="text-white">www.sikkait.com</strong> — your destination for 
            AI-powered software solutions, custom development, and digital transformation.
          </p>

          <p className="text-sm text-slate-500 mb-10">
            Connecting domain & DNS records{dots}
          </p>

          {/* Domain badge */}
          <div className="inline-flex items-center gap-2.5 px-5 py-2.5 rounded-full border border-slate-700/60 bg-slate-900/50 backdrop-blur mb-12">
            <Globe className="h-4 w-4 text-blue-400" />
            <span className="text-sm font-mono text-slate-300">www.sikkait.com</span>
            <span className="h-2 w-2 rounded-full bg-amber-400 animate-pulse" />
          </div>

          {/* CTA */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="mailto:raunak@sikkanet.com"
              className="group flex items-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-500 text-white rounded-lg transition-all text-sm font-medium"
              data-testid="contact-us-btn"
            >
              Contact Us
              <ArrowRight className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
            </a>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="relative z-10 py-8 px-6 md:px-12 border-t border-slate-800/50">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-slate-500">
          <div className="flex items-center gap-2">
            <MapPin className="h-4 w-4 text-slate-600" />
            <span>Sikka House, 6 La Place, Hazratganj, Lucknow - 226001</span>
          </div>
          <span>&copy; 2026 Sikka IT Solutions. All rights reserved.</span>
        </div>
      </footer>
    </div>
  );
};

export default ComingSoon;
